import { render } from "./SearchCharacters.vue?vue&type=template&id=4fbe70de&lang=html"
import script from "./SearchCharacters.vue?vue&type=script&lang=js"
export * from "./SearchCharacters.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__